import { currentUserShowSuccess, fetchCurrentUser } from '../../ducks/user.duck';
import merge from 'lodash/merge';

// ================ Action types ================ //

export const SET_INITIAL_STATE = 'app/PersonalInfoPage.duck/SET_INITIAL_STATE';
export const SAVE_PERSONAL_INFO_DETAILS_REQUEST =
    'app/PersonalInfoPage.duck/SAVE_PERSONAL_INFO_DETAILS_REQUEST';
export const SAVE_PERSONAL_INFO_DETAILS_SUCCESS =
    'app/PersonalInfoPage.duck/SAVE_PERSONAL_INFO_DETAILS_SUCCESS';
export const SAVE_PERSONAL_INFO_DETAILS_ERROR =
    'app/PersonalInfoPage.duck/SAVE_PERSONAL_INFO_DETAILS_ERROR';

// ================ Reducer ================ //

const initialState = {
    personalInfoDetailsSaveInProgress: false,
    personalInfoDetailsError: false,
};

export default function payoutPreferencesPageReducer(state = initialState, action = {}) {
    const { type } = action;
    switch (type) {
        case SET_INITIAL_STATE:
            return initialState;

        case SAVE_PERSONAL_INFO_DETAILS_REQUEST:
            return { ...state, personalInfoDetailsSaveInProgress: true };
        case SAVE_PERSONAL_INFO_DETAILS_SUCCESS:
            return { ...state, personalInfoDetailsSaveInProgress: false };
        case SAVE_PERSONAL_INFO_DETAILS_ERROR:
            return {
                ...state,
                personalInfoDetailsSaveInProgress: false,
                personalInfoDetailsError: true,
            };

        default:
            return state;
    }
}

// ================ Action creators ================ //

export const setInitialState = () => ({
    type: SET_INITIAL_STATE,
});
export const savePersonalInfoDetailsRequest = () => ({
    type: SAVE_PERSONAL_INFO_DETAILS_REQUEST,
});
export const savePersonalInfoDetailsError = () => ({
    type: SAVE_PERSONAL_INFO_DETAILS_ERROR,
});
export const savePersonalInfoDetailsSuccess = () => ({
    type: SAVE_PERSONAL_INFO_DETAILS_SUCCESS,
});

// ================ Thunks ================ //

export const savePersonalInfoDetails = values => (dispatch, getState, sdk) => {
    const {
        user: { currentUser },
    } = getState();

    const { country, city, postalCode, streetAddress, houseNumber, userLocation } = values;
    dispatch(savePersonalInfoDetailsRequest());

    const params = {
        publicData: {
            city: (city || '').trim(),
            streetAddress: (streetAddress || '').trim(),
            country,
            houseNumber,
            postalCode,
        },
    };

    if (userLocation) {
        params.publicData.userLocation = userLocation;
    }

    return sdk.currentUser
        .updateProfile(params)
        .then(response => {
            dispatch(savePersonalInfoDetailsSuccess());

            const personalInfoMergeSource = {
                attributes: { profile: { publicData: params.publicData } },
            };

            dispatch(currentUserShowSuccess(merge(currentUser, personalInfoMergeSource)));

            return response;
        })
        .catch(e => {
            dispatch(savePersonalInfoDetailsError());
            throw e;
        });
};

export const loadData = () => async (dispatch, getState, sdk) => {
    dispatch(setInitialState());

    return dispatch(fetchCurrentUser());
};
